import './HoopsViewerName.css';
import { jsx as n } from "react/jsx-runtime";
import o from "clsx";
import { truncateFileName as p } from "./HoopsViewerName.utils.mjs";
const m = "_wrapper_1v8cn_1", c = {
  wrapper: m
}, w = (e) => {
  const { name: r, length: s = 35, className: t } = e;
  if (!r)
    return null;
  const a = p(r, s);
  return /* @__PURE__ */ n("div", { className: o(c.wrapper, t), children: a });
};
export {
  w as H
};
//# sourceMappingURL=HoopsViewerName-DV6WCWJa.js.map
